/* eslint-disable max-len */

export default {
  state: {
    data: {},
    order: [],
    loading: false,
    error: null,
    queue: [],
    config: {
      default: 'NEWS',
      path: 'news',
      get: { active: true, msg: '' },
      update: { active: true, msg: '' },
      create: { active: true, msg: '' },
      delete: { active: true, msg: '' },
      admin: {
        get: { active: true, msg: '' },
        update: { active: true, msg: 'Neuigkeiten aktualisiert.' },
        create: { active: true, msg: 'Neuigkeiten erstellt.', rtr: 'AllNews' },
        delete: { active: true, msg: 'Neuigkeiten gelöscht.', rtr: 'AllNews' },
      },
    },
  },
  getters: {
    dataById: (state) => (id) => state.data[id] || {},
  },
  mutations: {},
  actions: {
    SOCKET_NEWS({ dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_NEWS`, payload);
      dispatch('HANDLE_PAYLOAD', payload[1]);

      // commit('SET_LOADING', false);
    },
  },
};

// Liebe User von Standortmonitor.net,<br />
// <br />
// wir haben unsere Plattform für Sie überarbeitet!<br />
// <br />
// Mit diesem Update erhalten Sie Zugriff auf <b>die aktuellsten offiziellen Standortdaten</b>. Darüber hinaus haben wir die <b>Performance unserer Dashboards verbessert</b> und diese um viele neue <b>Darstellungs- und Analyseformate</b> ergänzt. Zudem haben wir <b>unsere Seitenstruktur unter die Lupe genommen und neu sortiert</b>, damit Sie noch einfacher zu Ihren gesuchten Analysen gelangen.<br />
// <br />
// Sie haben aktuell weiterhin die Möglichkeit, den Standortmonitor in der bekannten Ansicht zu nutzen. Um zur gewohnten Ansicht zurückzukehren, nutzen Sie bitte das Auswahlfeld in der Navigationsseite und wählen Sie „Kultur- und Kreativwirtschaft – Version 2020 (alt)“ aus. Bitte beachten Sie jedoch, dass in dieser Version zukünftig keine Daten mehr aktualisiert werden.<br />
// <br />
// Wir wünschen Ihnen viel Freude mit der neuen Version und freuen uns über Ihr Feedback sowie Ihre Anregungen, Standortmonitor.net auch in Zukunft weiter zu verbessern und mit weiteren für Sie spannenden Inhalten und Analysen zu bereichern.<br />
// <br />
// Ihr Goldmedia-Team<br />
// <hr />
// <b>Wichtiger Hinweis:</b><br />
// Beim erstmaligen Laden der neuen Dashboards kann ein Versionskonflikt auftreten. Sollte dies der Fall sein gehen Sie bitte wie folgt vor:<br />
// 1) Navigieren Sie zu einem beliebigen Dashboard<br />
// 2) Kopieren Sie die URL aus der Browserzeile<br />
// 3) Schließen Sie den Standortmonitor-Tab<br />
// 4) Öffnen Sie einen neuen leeren Tab<br />
// 5) Fügen Sie die kopierte URL erneut in die Browserzeile ein und klicken anschließend <code>Enter</code>.<br />
